module.exports = __webpack_public_path__ + "img/description2.92037116.jpg";